import * as Yup from 'yup';

export const manufacturerListSchema = Yup.object({
  Description: Yup.string().required('Description is required'),
});
